import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TextSection from "@components/reviewsGuidelinesPage/TextSection/textSection";

const heroImage = {
  url: `${process.env.CDN_URL}/images/reviews-guidelines-hero-image.jpg`,
  alt: 'Reviews Guidelines Hero Image'
};

const ReviewsGuidelinesTemplate = ({ pageContext: { locale } }) => {
  const intl = useIntl();

  return (
    <Fragment>
      <SEO
        titleKey={intl.formatMessage({ id: "Review Guidelines" })}
        descriptionKey={intl.formatMessage({ id: "Review Guidelines" })}
        imageUrl={heroImage.url}
        lang={locale}
      />
      <HeroSection
        heroHeading={intl.formatMessage({ id: "Review Guidelines" })}
        heroImage={heroImage}
        height={240}
      />
      <UniplacesFullContainer>
          <TextSection
            title={intl.formatMessage({ id: 'Review Guidelines'})}
            text={intl.formatMessage({ id: 'Review Guidelines text'})}
          />
          <Controls />
      </UniplacesFullContainer>
    </Fragment>
  );
};

export default ReviewsGuidelinesTemplate;
